export function gql(strings, ...args) {
  let str = "";
  strings.forEach((string, i) => {
    str += string + (args[i] || "");
  });
  return str;
}
export const HomePartsFragmentDoc = gql`
    fragment HomeParts on Home {
  __typename
  header {
    __typename
    title
    subtitle
    button {
      __typename
      label
      link
    }
    carouselSpeed
    images {
      __typename
      image
      title
    }
  }
  whatWeDo {
    __typename
    sectionTitle
    title
    description
    items {
      __typename
      icon
      title
      description
      image
    }
  }
  valueProposition {
    __typename
    sectionTitle
    title
    description
    valuePropositions {
      __typename
      icon
      title
      description
    }
  }
  whoWeServe {
    __typename
    sectionTitle
    title
    items {
      __typename
      title
      description
    }
  }
  socialProof {
    __typename
    title
    logos {
      __typename
      name
      link
      image
    }
    testimonials {
      __typename
      image
      name
      description
      quote
    }
  }
  callToAction {
    __typename
    title
    description
    button {
      __typename
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
  }
}
    `;
export const MspsInfoPartsFragmentDoc = gql`
    fragment MspsInfoParts on MspsInfo {
  __typename
  header {
    __typename
    sectionTitle
    title
    description
    problems {
      __typename
      problem
    }
  }
  solutions {
    __typename
    sectionTitle
    title
    solutions {
      __typename
      title
      description
    }
  }
  callToActionSeparator {
    __typename
    title
    quote
    quoteAuthor
    button {
      __typename
      label
      link
    }
  }
  whyUs {
    __typename
    sectionTitle
    title
    reasons {
      __typename
      icon
      title
      description
    }
  }
  callToAction {
    __typename
    title
    description
    button {
      __typename
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
  }
}
    `;
export const CmmcCompliancePartsFragmentDoc = gql`
    fragment CmmcComplianceParts on CmmcCompliance {
  __typename
  header {
    __typename
    title
    description
    image
  }
  separator {
    __typename
    title
    background
  }
  security {
    __typename
    sectionTitle
    title
    description
    benefits {
      __typename
      title
    }
  }
  roadmap {
    __typename
    sectionTitle
    title
    description
    image
  }
  callToAction {
    __typename
    title
    description
    button {
      __typename
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
  }
}
    `;
export const AboutPartsFragmentDoc = gql`
    fragment AboutParts on About {
  __typename
  header {
    __typename
    title
    description
    button {
      __typename
      label
      link
    }
    channels {
      __typename
      icon
      title
      description
    }
  }
  exampleSections {
    __typename
    sectionTitle
    title
    description
    benefits {
      __typename
      label
    }
    examples {
      __typename
      icon
      title
      description
    }
    examplesFooter
  }
  callToAction {
    __typename
    title
    description
    button {
      __typename
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
  }
}
    `;
export const FrameworksPartsFragmentDoc = gql`
    fragment FrameworksParts on Frameworks {
  __typename
  header {
    __typename
    title
  }
  frameworkSections {
    __typename
    sectionTitle
    title
    frameworkItems {
      __typename
      title
      description
    }
  }
  moreInfoSection {
    __typename
    moreInfo
    description
  }
  callToAction {
    __typename
    title
    description
    button {
      __typename
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
  }
}
    `;
export const PricingPartsFragmentDoc = gql`
    fragment PricingParts on Pricing {
  __typename
  header {
    __typename
    title
  }
  pricingPackages {
    __typename
    packages {
      __typename
      title
      subtitle
      price
      discount
    }
    subtitle
    description
  }
  specials {
    __typename
    sectionTitle
    title
    items {
      __typename
      title
      description
      button {
        __typename
        label
        link
      }
    }
  }
  callToAction {
    __typename
    title
    description
    button {
      __typename
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
  }
}
    `;
export const PartnersPartsFragmentDoc = gql`
    fragment PartnersParts on Partners {
  __typename
  header {
    __typename
    title
    subtitle
  }
  trustedBy {
    __typename
    title
    logos {
      __typename
      image
      logoLink
      logoName
    }
  }
  partnerProgram {
    __typename
    title
    description
    button {
      __typename
      label
      link
    }
  }
  partnerTypes {
    __typename
    title
    partnerTypes {
      __typename
      image
      title
      description
    }
  }
  whyUs {
    __typename
    sectionTitle
    title
    subtitle
    items {
      __typename
      icon
      title
      description
    }
  }
  callToAction {
    __typename
    title
    description
    button {
      __typename
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
  }
}
    `;
export const RequestDemoPartsFragmentDoc = gql`
    fragment RequestDemoParts on RequestDemo {
  __typename
  header {
    __typename
    title
    description
    demoBenefits {
      __typename
      description
    }
  }
  successMessage {
    __typename
    title
    subtitle
  }
  demoDetails {
    __typename
    sectionTitle
    title
    subtitle
    items {
      __typename
      icon
      title
      description
    }
  }
  seo {
    __typename
    title
    description
    keywords
  }
}
    `;
export const LoginPartsFragmentDoc = gql`
    fragment LoginParts on Login {
  __typename
  header {
    __typename
    title
    subtitle
  }
  loginOptions {
    __typename
    loginOptions {
      __typename
      title
      description
      button {
        __typename
        label
        link
      }
    }
  }
  callToAction {
    __typename
    title
    description
    button {
      __typename
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
  }
}
    `;
export const ContactPartsFragmentDoc = gql`
    fragment ContactParts on Contact {
  __typename
  header {
    __typename
    title
    description
    contactDetails {
      __typename
      icon
      label
      url
    }
  }
  contactForm {
    __typename
    title
    description
    successMessage {
      __typename
      title
      subtitle
    }
  }
  callToAction {
    __typename
    title
    description
    button {
      __typename
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
  }
}
    `;
export const TeamPagePartsFragmentDoc = gql`
    fragment TeamPageParts on TeamPage {
  __typename
  header {
    __typename
    title
    subtitle
  }
  team {
    __typename
    members {
      __typename
      name
      role
      description
      linkedinUrl
      image
    }
  }
  callToAction {
    __typename
    title
    description
    button {
      __typename
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
  }
}
    `;
export const FaqsPagePartsFragmentDoc = gql`
    fragment FaqsPageParts on FaqsPage {
  __typename
  header {
    __typename
    title
    subtitle
  }
  faqs {
    __typename
    questions {
      __typename
      question
      answer
    }
  }
  callToAction {
    __typename
    title
    description
    button {
      __typename
      label
      link
    }
  }
  seo {
    __typename
    title
    description
    keywords
  }
}
    `;
export const LegalPartsFragmentDoc = gql`
    fragment LegalParts on Legal {
  __typename
  title
  body
  seo {
    __typename
    title
    description
    keywords
  }
}
    `;
export const GlobalPartsFragmentDoc = gql`
    fragment GlobalParts on Global {
  __typename
  navItems {
    __typename
    navLinks {
      __typename
      label
      link
    }
    navButtons {
      __typename
      label
      link
    }
  }
  links {
    __typename
    footerLinks {
      __typename
      label
      link
    }
    footerLinksSecondary {
      __typename
      label
      link
    }
  }
  socials {
    __typename
    socialLinks {
      __typename
      platform
      url
    }
  }
  tooltips {
    __typename
    tooltips {
      __typename
      word
      title
      description
    }
  }
  seo {
    __typename
    title
    description
    keywords
    image
  }
}
    `;
export const HomeDocument = gql`
    query home($relativePath: String!) {
  home(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...HomeParts
  }
}
    ${HomePartsFragmentDoc}`;
export const HomeConnectionDocument = gql`
    query homeConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: HomeFilter) {
  homeConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...HomeParts
      }
    }
  }
}
    ${HomePartsFragmentDoc}`;
export const MspsInfoDocument = gql`
    query mspsInfo($relativePath: String!) {
  mspsInfo(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...MspsInfoParts
  }
}
    ${MspsInfoPartsFragmentDoc}`;
export const MspsInfoConnectionDocument = gql`
    query mspsInfoConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: MspsInfoFilter) {
  mspsInfoConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...MspsInfoParts
      }
    }
  }
}
    ${MspsInfoPartsFragmentDoc}`;
export const CmmcComplianceDocument = gql`
    query cmmcCompliance($relativePath: String!) {
  cmmcCompliance(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...CmmcComplianceParts
  }
}
    ${CmmcCompliancePartsFragmentDoc}`;
export const CmmcComplianceConnectionDocument = gql`
    query cmmcComplianceConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: CmmcComplianceFilter) {
  cmmcComplianceConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...CmmcComplianceParts
      }
    }
  }
}
    ${CmmcCompliancePartsFragmentDoc}`;
export const AboutDocument = gql`
    query about($relativePath: String!) {
  about(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...AboutParts
  }
}
    ${AboutPartsFragmentDoc}`;
export const AboutConnectionDocument = gql`
    query aboutConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: AboutFilter) {
  aboutConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...AboutParts
      }
    }
  }
}
    ${AboutPartsFragmentDoc}`;
export const FrameworksDocument = gql`
    query frameworks($relativePath: String!) {
  frameworks(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...FrameworksParts
  }
}
    ${FrameworksPartsFragmentDoc}`;
export const FrameworksConnectionDocument = gql`
    query frameworksConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: FrameworksFilter) {
  frameworksConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...FrameworksParts
      }
    }
  }
}
    ${FrameworksPartsFragmentDoc}`;
export const PricingDocument = gql`
    query pricing($relativePath: String!) {
  pricing(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...PricingParts
  }
}
    ${PricingPartsFragmentDoc}`;
export const PricingConnectionDocument = gql`
    query pricingConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: PricingFilter) {
  pricingConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...PricingParts
      }
    }
  }
}
    ${PricingPartsFragmentDoc}`;
export const PartnersDocument = gql`
    query partners($relativePath: String!) {
  partners(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...PartnersParts
  }
}
    ${PartnersPartsFragmentDoc}`;
export const PartnersConnectionDocument = gql`
    query partnersConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: PartnersFilter) {
  partnersConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...PartnersParts
      }
    }
  }
}
    ${PartnersPartsFragmentDoc}`;
export const RequestDemoDocument = gql`
    query requestDemo($relativePath: String!) {
  requestDemo(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...RequestDemoParts
  }
}
    ${RequestDemoPartsFragmentDoc}`;
export const RequestDemoConnectionDocument = gql`
    query requestDemoConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: RequestDemoFilter) {
  requestDemoConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...RequestDemoParts
      }
    }
  }
}
    ${RequestDemoPartsFragmentDoc}`;
export const LoginDocument = gql`
    query login($relativePath: String!) {
  login(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...LoginParts
  }
}
    ${LoginPartsFragmentDoc}`;
export const LoginConnectionDocument = gql`
    query loginConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: LoginFilter) {
  loginConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...LoginParts
      }
    }
  }
}
    ${LoginPartsFragmentDoc}`;
export const ContactDocument = gql`
    query contact($relativePath: String!) {
  contact(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...ContactParts
  }
}
    ${ContactPartsFragmentDoc}`;
export const ContactConnectionDocument = gql`
    query contactConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: ContactFilter) {
  contactConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...ContactParts
      }
    }
  }
}
    ${ContactPartsFragmentDoc}`;
export const TeamPageDocument = gql`
    query teamPage($relativePath: String!) {
  teamPage(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...TeamPageParts
  }
}
    ${TeamPagePartsFragmentDoc}`;
export const TeamPageConnectionDocument = gql`
    query teamPageConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: TeamPageFilter) {
  teamPageConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...TeamPageParts
      }
    }
  }
}
    ${TeamPagePartsFragmentDoc}`;
export const FaqsPageDocument = gql`
    query faqsPage($relativePath: String!) {
  faqsPage(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...FaqsPageParts
  }
}
    ${FaqsPagePartsFragmentDoc}`;
export const FaqsPageConnectionDocument = gql`
    query faqsPageConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: FaqsPageFilter) {
  faqsPageConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...FaqsPageParts
      }
    }
  }
}
    ${FaqsPagePartsFragmentDoc}`;
export const LegalDocument = gql`
    query legal($relativePath: String!) {
  legal(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...LegalParts
  }
}
    ${LegalPartsFragmentDoc}`;
export const LegalConnectionDocument = gql`
    query legalConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: LegalFilter) {
  legalConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...LegalParts
      }
    }
  }
}
    ${LegalPartsFragmentDoc}`;
export const GlobalDocument = gql`
    query global($relativePath: String!) {
  global(relativePath: $relativePath) {
    ... on Document {
      _sys {
        filename
        basename
        hasReferences
        breadcrumbs
        path
        relativePath
        extension
      }
      id
    }
    ...GlobalParts
  }
}
    ${GlobalPartsFragmentDoc}`;
export const GlobalConnectionDocument = gql`
    query globalConnection($before: String, $after: String, $first: Float, $last: Float, $sort: String, $filter: GlobalFilter) {
  globalConnection(
    before: $before
    after: $after
    first: $first
    last: $last
    sort: $sort
    filter: $filter
  ) {
    pageInfo {
      hasPreviousPage
      hasNextPage
      startCursor
      endCursor
    }
    totalCount
    edges {
      cursor
      node {
        ... on Document {
          _sys {
            filename
            basename
            hasReferences
            breadcrumbs
            path
            relativePath
            extension
          }
          id
        }
        ...GlobalParts
      }
    }
  }
}
    ${GlobalPartsFragmentDoc}`;
export function getSdk(requester) {
  return {
    home(variables, options) {
      return requester(HomeDocument, variables, options);
    },
    homeConnection(variables, options) {
      return requester(HomeConnectionDocument, variables, options);
    },
    mspsInfo(variables, options) {
      return requester(MspsInfoDocument, variables, options);
    },
    mspsInfoConnection(variables, options) {
      return requester(MspsInfoConnectionDocument, variables, options);
    },
    cmmcCompliance(variables, options) {
      return requester(CmmcComplianceDocument, variables, options);
    },
    cmmcComplianceConnection(variables, options) {
      return requester(CmmcComplianceConnectionDocument, variables, options);
    },
    about(variables, options) {
      return requester(AboutDocument, variables, options);
    },
    aboutConnection(variables, options) {
      return requester(AboutConnectionDocument, variables, options);
    },
    frameworks(variables, options) {
      return requester(FrameworksDocument, variables, options);
    },
    frameworksConnection(variables, options) {
      return requester(FrameworksConnectionDocument, variables, options);
    },
    pricing(variables, options) {
      return requester(PricingDocument, variables, options);
    },
    pricingConnection(variables, options) {
      return requester(PricingConnectionDocument, variables, options);
    },
    partners(variables, options) {
      return requester(PartnersDocument, variables, options);
    },
    partnersConnection(variables, options) {
      return requester(PartnersConnectionDocument, variables, options);
    },
    requestDemo(variables, options) {
      return requester(RequestDemoDocument, variables, options);
    },
    requestDemoConnection(variables, options) {
      return requester(RequestDemoConnectionDocument, variables, options);
    },
    login(variables, options) {
      return requester(LoginDocument, variables, options);
    },
    loginConnection(variables, options) {
      return requester(LoginConnectionDocument, variables, options);
    },
    contact(variables, options) {
      return requester(ContactDocument, variables, options);
    },
    contactConnection(variables, options) {
      return requester(ContactConnectionDocument, variables, options);
    },
    teamPage(variables, options) {
      return requester(TeamPageDocument, variables, options);
    },
    teamPageConnection(variables, options) {
      return requester(TeamPageConnectionDocument, variables, options);
    },
    faqsPage(variables, options) {
      return requester(FaqsPageDocument, variables, options);
    },
    faqsPageConnection(variables, options) {
      return requester(FaqsPageConnectionDocument, variables, options);
    },
    legal(variables, options) {
      return requester(LegalDocument, variables, options);
    },
    legalConnection(variables, options) {
      return requester(LegalConnectionDocument, variables, options);
    },
    global(variables, options) {
      return requester(GlobalDocument, variables, options);
    },
    globalConnection(variables, options) {
      return requester(GlobalConnectionDocument, variables, options);
    }
  };
}
import { createClient } from "tinacms/dist/client";
const generateRequester = (client) => {
  const requester = async (doc, vars, options) => {
    let url = client.apiUrl;
    if (options?.branch) {
      const index = client.apiUrl.lastIndexOf("/");
      url = client.apiUrl.substring(0, index + 1) + options.branch;
    }
    const data = await client.request({
      query: doc,
      variables: vars,
      url
    }, options);
    return { data: data?.data, errors: data?.errors, query: doc, variables: vars || {} };
  };
  return requester;
};
export const ExperimentalGetTinaClient = () => getSdk(
  generateRequester(
    createClient({
      url: "https://content.tinajs.io/3.0/content/43df56f8-f91f-4c3d-ab57-cc99b7c6512b/github/main",
      queries
    })
  )
);
export const queries = (client) => {
  const requester = generateRequester(client);
  return getSdk(requester);
};
